import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSalon } from './SalonContext';
import moment from 'moment';
const CalendarContext = createContext(null);

export function CalendarProvider({ children }) {
  const { services, employees } = useSalon();
  const [staffServices, setStaffServices] = useState();

  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [selectedArtists, setSelectedArtists] = useState(['all']);
  const [selectedService, setSelectedService] = useState('all');

  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedView, setSelectedView] = useState('day');

  useEffect(() => {
    if (selectedView !== 'week' && selectedView !== 'day') {
      setSelectedView('day');
    }
  }, [selectedView]);

  const [dateRange, setDateRange] = useState({
    start: moment().startOf('week').format('YYYY-MM-DD'),
    end: moment().endOf('week').add(1, 'day').format('YYYY-MM-DD')
  });

  useEffect(() => {
    // Always use week view to reduce # of API calls
    const start = moment(selectedDate).startOf("week").format('YYYY-MM-DD');
    const end = moment(selectedDate).endOf("week").add(1, 'day').format('YYYY-MM-DD');
    
    if (!dateRange.start || !dateRange.end || 
        moment(selectedDate).isBefore(dateRange.start) || 
        moment(selectedDate).isAfter(dateRange.end)) {
      setDateRange({ start, end });
    }
  }, [selectedDate]);

  useEffect(() => {
    if (services) {
      const staffServices = services.flatMap(salonService => 
        salonService.servicing_staff.map(staffService => ({
          id: staffService.id,
          salonServiceId: salonService.id,
          staffId: staffService.staff_id,
        }))
      );

      setStaffServices(staffServices);
    }
  }, [services]);

  useEffect(() => {
    if (employees) {
      if (selectedArtists.includes('all')) {
        setFilteredEmployees(employees);
      } else {
        setFilteredEmployees(employees.filter(employee => 
          selectedArtists.includes(employee.id)
        ));
      }
    }
  }, [selectedArtists, employees]);

  const value = {
    staffServices,
    selectedArtists,
    selectedService,
    filteredEmployees,
    selectedDate,
    selectedView,
    dateRange,
    setSelectedArtists,
    setSelectedService,
    setSelectedDate,
    setSelectedView,
    setDateRange
  };

  return (
    <CalendarContext.Provider value={value}>
      {children}
    </CalendarContext.Provider>
  );
}

export const useCalendar = () => {
  const context = useContext(CalendarContext);
  if (!context) {
    throw new Error('useCalendar must be used within a CalendarProvider');
  }
  return context;
}; 